var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.variant === 'gwp')?_c('p',{staticClass:"c-cart-offer-copy",class:[
    't-paragraph-small',
    'u-center-text'
  ]},[_vm._v("\n  "+_vm._s(_vm.gwpMessage)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }